import React, { useEffect, useState } from "react";
import axios from "axios";
import MapView from "./MapView";
function App() {
  const [files, setFiles] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);

  // Load file list
  useEffect(() => {
    fetchFiles();
  }, []);

  useEffect(() => {
    selectAll();
  }, [files]);

  const fetchFiles = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/files`);
      setFiles(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const toggleFileSelection = (fileId) => {
    setSelectedFiles((prev) =>
      prev.includes(fileId)
        ? prev.filter((f) => f !== fileId)
        : [...prev, fileId]
    );
  };

  const selectAll = () => {
    setSelectedFiles(files.map((f) => f.id));
  };

  const clearAll = () => {
    setSelectedFiles([]);
  };

  return (
    <div style={{ display: "flex" }}>
      {/* Left panel */}
      <div
        style={{
          width: "450px",
          borderRight: "1px solid #ccc",
          padding: "1rem",
        }}
      >
        <h3>Files</h3>
        <div>
          <button onClick={selectAll}>Check all</button>
          <button onClick={clearAll}>Clear all</button>
        </div>
        <ul style={{ listStyle: "none", paddingLeft: 0 }}>
          {files.map((file) => (
            <li key={file.id} style={{ margin: "0.5rem 0" }}>
              <input
                type="checkbox"
                checked={selectedFiles.includes(file.id)}
                onChange={() => toggleFileSelection(file.id)}
              />
              <span style={{ marginLeft: "0.5rem" }}>
                {file.username} | {new Date(file.timestamp).toLocaleString()}
              </span>
              <a
                href={`${
                  process.env.REACT_APP_API_URL
                }/files/${encodeURIComponent(file.id)}/download`}
                style={{ marginLeft: "0.5rem" }}
                download
              >
                Download
              </a>
              {/* <button
                style={{
                  marginLeft: "0.5rem",
                  fontSize: "16px",
                  background: "none",
                  border: "none",
                  color: "blue",
                  cursor: "pointer",
                  fontFamily: "Times",
                  textDecoration: "underline",
                }}
                onClick={async () => {
                  try {
                    const response = await fetch(
                      `${
                        process.env.REACT_APP_API_URL
                      }/files/${encodeURIComponent(file.id)}/delete`
                    );
                    if (response.ok) {
                      alert("File deleted successfully");
                    } else {
                      alert("Failed to delete file");
                    }
                  } catch (error) {
                    console.log(error);
                    // alert("Error deleting file");
                  }
                }}
              >
                Delete
              </button> */}
            </li>
          ))}
        </ul>
      </div>

      {/* Right panel */}
      <div style={{ flex: 1, padding: "1rem" }}>
        <h2>MAP VIEW</h2>
        <MapView selectedFiles={selectedFiles} />
      </div>
    </div>
  );
}

export default App;
